import { useEffect } from "react";
import { useContent } from "../context/ContentContext";

export default function SeoSchema() {
  const { content } = useContent();

  useEffect(() => {
    if (!content) return;
    const c = content.contact || {};
    const reviews = content.reviews || [];
    const avg = reviews.length
      ? (reviews.reduce((a, r) => a + (Number(r.rating) || 5), 0) / reviews.length).toFixed(1)
      : null;

    const schema = {
      "@context": "https://schema.org",
      "@type": "LandscapingBusiness",
      name: "Zurita's Tree Services & Landscaping",
      image: `${window.location.origin}/logo.jpg`,
      "@id": window.location.origin,
      url: window.location.origin,
      telephone: c.phone || "540-314-1957",
      email: c.email || undefined,
      priceRange: "$$",
      areaServed: c.area_en || "Winchester, VA and surrounding areas",
      description:
        "Professional tree removal, stone work, fire pits, chimneys and landscaping. Free estimates.",
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        opens: "07:00",
        closes: "19:00",
      },
      sameAs: [c.facebook, c.instagram, content.google_url].filter(Boolean),
    };

    if (avg && reviews.length) {
      schema.aggregateRating = {
        "@type": "AggregateRating",
        ratingValue: avg,
        reviewCount: String(reviews.length),
      };
    }

    const id = "ld-localbusiness";
    document.getElementById(id)?.remove();
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    el.text = JSON.stringify(schema);
    document.head.appendChild(el);
    return () => document.getElementById(id)?.remove();
  }, [content]);

  return null;
}
